import apiFetch from '../apiFetch'

export default function (token, conditionNoDocumental) {
  return apiFetch({ endPoint: 'conditionNoDocumental', method: 'POST', body: conditionNoDocumental, token: token })
}
